export default __webpack_public_path__ + "static/eng-3-aa235a2f3f15a8eaca0c1598c8720113.jpg";